module.exports = __webpack_public_path__ + "img/HU10816291.d54cc204.png";